function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        resident: {
            default: null
        },
        property: {
            default: null
        },
        building: {
            default: null
        },
        unit: {
            default: null
        }

    },
    data: function data() {
        return {
            assignee: {},
            formData: {},
            reportedBy: '',
            description: '',
            image: [],
            imagesToSend: [],
            imageBlob: '',
            status: '',
            priority: '',
            category: '',
            illness: '',
            distance: '',
            buildings: [],
            units: [],
            allUnits: [],
            residents: [],
            users: [],
            properties: [],
            propertySelect: '',
            buildingSelect: '',
            unitSelect: '',
            firstTimeUnitSelected: false,
            firstTimeResidentSelected: false,
            isLoading: false,
            showUnit: false,
            vendors: [],
            phone: '',
            priorityOptions: [{ value: 4, name: 'Urgent' }, { value: 3, name: 'High' }, { value: 2, name: 'Medium' }, { value: 1, name: 'Low' }],
            categories: ['Appliances', 'Assess', 'Carpet', 'Clean', 'Drywall / Sheetrock', 'Electrical', 'General Maintenance', 'Hurricane Related', 'HVAC', 'Lighting', 'Lock Change', 'Make Ready Classic', 'Made Ready Partial', 'Make Ready Rehab', 'MR Demo', 'Paint', 'Pest Control', 'Plumbing', 'Pull Carpet', 'Rehab Kit', 'Rekey', 'Resurface', 'Rodents', 'Roof', 'Sewer', 'Strip', 'Vinyl', 'Walk-Through'],
            IllnessOptions: ['Yes', 'No', 'Unknown'],
            distanceOptions: ['Agree', 'Disagree', 'Unknown']
        };
    },
    mounted: function mounted() {
        this.priority = { value: 1, name: 'Low' };
    },
    created: function created() {
        Event.$on('add-service-request', this.addServiceRequest);
        Event.$on('serviceRequestAdded', this.serviceRequestAdded);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('add-service-request');
        Event.$off('serviceRequestAdded');
    },

    methods: {
        addServiceRequest: function addServiceRequest() {
            var $el = this;
            console.log('caught add-service-request');
            $el.$children[0].$data.showModal = true;
            if ($el.property) {
                $el.propertySelect = $el.property;
            }
            if ($el.resident || $el.building) {
                this.refreshForm();
            }

            axios.get('/prototype/users/all').then(function (response) {
                $el.users = response.data;
            });

            axios.get('/prototype/vendors/all').then(function (response) {
                $el.vendors = response.data;
            });
        },
        serviceRequestAdded: function serviceRequestAdded() {
            var $el = this;
            $el.$children[0].$data.showModal = false;
            $el.$snotify.success('The service request was added');
        },
        refreshForm: function refreshForm() {
            var $el = this;
            if ($el.property) {
                $el.propertySelect = $el.property;
            }

            var buildingUrl = $el.building ? '/prototype/properties/quick/' + $el.building.property_id + '/buildings' : '/prototype/properties/units';

            if ($el.building) {
                axios.get(buildingUrl).then(function (response) {
                    if (response.data) {
                        if ($el.building) {
                            $el.buildings = response.data;
                            $el.buildingSelect = $el.building;
                            $el.propertySelect = $el.building.property;
                        } else {
                            $el.units = response.data;
                        }
                    }
                });
            }

            if ($el.resident) {
                $el.firstTimeUnitSelected = true;
                $el.firstTimeResidentSelected = true;
                axios.get('/prototype/properties/quick/lookup').then(function (response) {
                    if (response.data) {
                        $el.propertySelect = response.data.selected;
                    }
                });

                if ($el.resident.unit.building_id) {
                    axios.get('/prototype/units/showBuilding/' + $el.resident.unit.building_id + '').then(function (response) {
                        if (response.data) {
                            $el.buildingSelect = response.data;
                        }
                    });
                    $el.unitSelect = $el.resident.unit;
                    $el.reportedBy = {
                        label: $el.resident.full_name,
                        value: 'resident:' + $el.resident.id
                    };
                }
            }

            if ($el.unit && $el.unit.building_id) {
                axios.get('/prototype/units/showBuilding/' + $el.unit.building_id + '').then(function (response) {
                    if (response.data) {
                        axios.get('/prototype/properties/quick/' + response.data.property_id + '/buildings').then(function (response) {
                            if (response.data) {
                                $el.buildings = response.data;
                                $el.buildingSelect = $el.unit.building;
                            }
                        });
                    }
                });
            }

            if ($el.person) {
                console.log('ADD LOGIC HERE: ServiceRequestAdd refreshForm() person:');
            }
        },
        submitRequest: function submitRequest() {
            // reportedBy object validation
            if (Object.keys(this.reportedBy).length < 2) {
                this.$snotify.error('Reported by is required');
                return false;
            }

            // assignee object validation
            if (Object.keys(this.assignee).length < 2) {
                this.$snotify.error('Assignee is required');
                return false;
            }

            var $el = this;
            var formData = new FormData();
            formData.append('property', $el.propertySelect.id);
            formData.append('building', $el.buildingSelect.id);
            if ($el.unitSelect) {
                formData.append('unit', $el.unitSelect.id);
            }

            var reportable = $el.reportedBy.value.split(':');

            // Assignee
            var assignee = $el.assignee.value.split(':');

            formData.append('reportedType', reportable[0]);
            formData.append('reportedBy', reportable[1]);
            formData.append('description', $el.description);
            formData.append('priority', $el.priority.value);
            this.imagesToSend.forEach(function (element, index) {
                formData.append('image[]', element);
            });
            formData.append('category', this.category);
            formData.append('illness', this.illness);
            formData.append('distance', this.distance);
            formData.append('phone', this.phone);
            formData.append('assigneeType', assignee[0]);
            formData.append('assigneeId', assignee[1]);
            $el.isLoading = true;
            axios.post('/prototype/servicerequests/store', formData).then(function (response) {
                $el.isLoading = false;
                $el.$emit('serviceRequestAdded');
                Event.$emit('refresh-service', response, 'add');
                $el.clearForm();
                Event.$emit('close-full-modal');
            });
        },
        clearForm: function clearForm() {
            var $el = this;
            $el.loading = false;
            $el.active = false;
            $el.priority = '';
            $el.category = '';
            $el.phone = '';
            $el.illness = '';
            $el.distance = '';
            $el.$children[0].$data.showModal = false;
            $el.description = '';
            if ($el.property) {
                $el.buildingSelect = '';
                $el.unitSelect = '';
                $el.reportedBy = '';
            } else if ($el.building) {
                $el.buildingSelect = $el.building;
                $el.unitSelect = '';
                $el.reportedBy = '';
            } else if ($el.unit) {
                $el.reportedBy = '';
            }
        },

        inputImage: function inputImage(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            // Create a blob field
            newFile.blob = '';
            var URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
                newFile.thumb = newFile.blob;
                this.imageBlob = newFile.file;
                this.imagesToSend.push(newFile.file);
            }
        }
    },

    watch: {
        propertySelect: function propertySelect() {
            var $el = this;
            axios.get('/prototype/properties/quick/' + $el.propertySelect.id + '/buildings').then(function (response) {
                if (response.data) {
                    $el.buildings = response.data;
                    if ($el.building) {
                        $el.buildingSelect = $el.building;
                    }
                }
            });
        },
        buildingSelect: function buildingSelect() {
            var $el = this;
            if ($el.buildingSelect) {
                $el.showUnit = $el.buildingSelect.structure_type_id === 1;
                $el.units = $el.buildingSelect.units;
                if (!($el.resident && $el.firstTimeUnitSelected)) {
                    $el.unitSelect = '';
                }
                if ($el.unit) {
                    $el.unitSelect = $el.unit;
                }

                // Get building
                axios.get('/prototype/residents/showBuilding/' + $el.buildingSelect.id).then(function (response) {
                    if (response.data) {
                        var payLoad = [];
                        response.data.forEach(function (element) {
                            payLoad.push({ "id": element.id, "full_name": element.person.full_name, "phone": element.person.phone });
                        });
                        if (!($el.resident && $el.firstTimeResidentSelected)) {
                            $el.reportedBy = '';
                        }
                        $el.residents = payLoad;
                        $el.firstTimeResidentSelected = false;
                    }
                });

                // Get users
                axios.get('/prototype/users/all').then(function (response) {
                    $el.users = response.data;
                });

                $el.firstTimeUnitSelected = false;
            }
        },
        reportedBy: function reportedBy() {
            var $el = this;
            if ($el.reportedBy) {
                $el.phone = $el.reportedBy.phone;
                // console.log($el.reportedBy);
            }
        },
        unit: function unit(newVal, oldVal) {
            if (newVal != oldVal) {
                this.refreshForm();
            }
        },
        building: function building(newVal, oldVal) {
            if (newVal != oldVal) {
                this.refreshForm();
            }
        },
        property: function property(newVal, oldVal) {
            if (newVal != oldVal) {
                this.refreshForm();
            }
        },
        resident: function resident(newVal, oldVal) {
            if (newVal != oldVal) {
                this.refreshForm();
            }
        }
    },
    computed: {
        reportedBySelect: function reportedBySelect() {

            var output = [],
                self = this;

            self.residents.forEach(function (r, index) {

                var item = {
                    label: r.full_name + ' (Resident)',
                    value: 'resident:' + r.id
                };

                output.push(item);
            });

            self.users.forEach(function (u, index) {

                var item = {
                    label: u.first_name + ' ' + u.last_name + ' (User)',
                    value: 'user:' + u.id
                };

                output.push(item);
            });

            return output;
        },
        assigneeSelect: function assigneeSelect() {

            var users = this.users.map(function (u) {
                return {
                    label: u.first_name + ' ' + u.last_name + ' (User)',
                    value: 'user:' + u.id
                };
            });

            var vendors = this.vendors.map(function (v) {
                return {
                    label: v.name + ' (Vendor)',
                    value: 'vendor:' + v.id
                };
            });

            return [].concat(_toConsumableArray(users), _toConsumableArray(vendors));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/ServiceRequestAdd.vue
// module id = WqCH
// module chunks = 0 1